import { createDrawerNavigator } from "@react-navigation/drawer"

export const Drawer = createDrawerNavigator()
